import React from "react";
import { BrowserRouter as Router, Routes, Route, Form } from "react-router-dom";
import Header from "./component/Header";
import Footer from "./component/Footer";
import About from "./component/About";
import Career from "./component/Career";
import ContactUs from "./component/ContactUs";
import Home from "./component/Home";
import Private from "./component/Private";
import LLP from "./component/LLP";
import Oneperson from "./component/Oneperson";
import Patnership from "./component/Patnership";
import GST from "./component/GST";
import Udyam from "./component/Udyam";
import IEC from "./component/IEC";
import Acc from "./component/Acc"; 
import TaxAdit from "./component/TaxAdit";
import StatutoryAudit from "./component/StatutoryAudit";
import GSTAudit from "./component/GSTAudit";
import Internal from "./component/Internal";
import Concurry from "./component/Concurry";
import GSTReturn from "./component/GSTReturn";
import TDS from "./component/TDS";
import GSTRefund from "./component/GSTRefund";
import Incometax from "./component/Incometax";
import Startups from "./component/Startups";
import RCMBasic from "./component/RCMBasic";
import Office from "./component/Office";
import ITRBasic from "./component/ITRBasic";
import Export from "./component/Export";
import Digital from "./component/Digital";
import Exportbenifits from "./component/Exportbenifits";
import Knowledge from "./component/Knowledge";

function App() {
  return (
    <>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/private" element={<Private />} />
          <Route path="/LLP" element={<LLP />} />
          <Route path="/Oneperson" element={<Oneperson />} />
          <Route path="/Patnership" element={<Patnership />} />
          <Route path="/GST" element={<GST />} />
          <Route path="/Udyam" element={<Udyam />} />
          <Route path="/IEC" element={<IEC />} />
          <Route path="/Acc" element={<Acc />} /> 
          <Route path="/TaxAdit" element={<TaxAdit />} />
          <Route path="/StatutoryAudit" element={<StatutoryAudit />} />
          <Route path="/GSTAudit" element={<GSTAudit />} />
          <Route path="/Internal" element={<Internal />} />
          <Route path="/Concurry" element={<Concurry />} />
          <Route path="/GSTReturn" element={<GSTReturn />} />
          <Route path="/TDS" element={<TDS />} />
          <Route path="/GSTRefund" element={<GSTRefund />} />
          <Route path="/Incometax" element={<Incometax />} />
          <Route path="/Knowledge" element={<Knowledge />} />
          <Route path="/tartups" element={<Startups />} />
          <Route path="/RCMBasic" element={<RCMBasic/>} />
          <Route path="/office" element={<Office/>} />
          <Route path="/ITRBasic " element={<ITRBasic />} />
          <Route path="/Export" element={<Export />} />
          <Route path="/Exportbenifits" element={<Exportbenifits />} />
          <Route path="/Digital" element={<Digital />} />
          <Route path="/About" element={<About />} />
          <Route path="/Career" element={<Career />} />
          <Route path="/ContactUs" element={<ContactUs />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
